<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <!--EmFilterTree-->
            <em-filter-tree class="col-lg-3 float-lg-left"
                            filterEnable
                            :entity="modelName"
                            filterState="levelTreeFilter"
                            loadState="levelTreeNodes"
                            :selectedId="$_emLevelTreeListMixin_menuTreeSelectedId"
                            @onclick="$_emLevelTreeListMixin_menuTreeOnClick"></em-filter-tree>
            <div class="float-lg-right col-lg-9">
                <div id="accordionFilter" class="content">
                    <div class="card">
                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                             data-parent="#accordionFilter">
                            <div class="card-body">
                                <form>
                                    <em-filter :entity="modelName" ref="emListFilter"
                                               @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="emOpcComputedEocResultTable" class="content">
                    <div class="card my-1">
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                             data-parent="#accordionResult">
                            <div class="card-body">
                                <em-table :entity="modelName"
                                          ref="emTable"
                                          withCustomRowActions exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                    <template #left-header>
                                        <em-button type="import"
                                                   custom-label="从订阅拷贝计算属性到当前选中节点下"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   :busy="onCopyFromSubscript"
                                                   :disabled="actionDisabled('selectOne')"
                                                   v-b-modal.modal-copy-from-subscript
                                        >
                                        </em-button>
                                        <em-button type="check" custom-icon="fa fa-refresh"
                                                   custom-label="重新组态"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   :busy="onReInit"
                                                   @click="reInit"
                                        ></em-button>
                                    </template>
                                    <template #customRowActions="{row}">
                                        <!--                                        <b-button-group>-->
                                        <!--                                            <em-button-->
                                        <!--                                                    v-if="$_emLevelTreeListMixin_getGrandParentId(row)"-->
                                        <!--                                                    type="gotoGrandParent"-->
                                        <!--                                                    v-bind:class="'btn btn-outline-primary btn-sm'"-->
                                        <!--                                                    @click="$_emLevelTreeListMixin_gotoGrandParentLevel(row)">-->
                                        <!--                                            </em-button>-->
                                        <!--                                            <em-button type="gotoChild"-->
                                        <!--                                                       v-bind:class="'btn btn-outline-primary btn-sm'"-->
                                        <!--                                                       @click="$_emLevelTreeListMixin_gotoChild(row)">-->
                                        <!--                                            </em-button>-->
                                        <!--                                        </b-button-group>-->
                                        <b-button-group>
                                            <em-button type="gotoChild"
                                                       v-bind:class="'btn btn-outline-primary btn-sm'"
                                                       custom-icon="fa fa-eye"
                                                       custom-label="监听"
                                                       @click="gotoEow(row)">
                                            </em-button>
                                            <em-button type="gotoChild"
                                                       v-bind:class="'btn btn-outline-primary btn-sm'"
                                                       custom-label="动作"
                                                       custom-icon="fa fa-angle-down"
                                                       @click="popEoca(row)">
                                            </em-button>
                                            <em-button type="gotoChild"
                                                       v-bind:class="'btn btn-outline-primary btn-sm'"
                                                       custom-label="事件"
                                                       custom-icon="fa fa-angle-up"
                                                       @click="gotoEoce(row)">
                                            </em-button>
                                        </b-button-group>
                                    </template>
                                </em-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"/>
        <b-modal id="modal-copy-from-subscript" title="从订阅拷贝计算属性到当前选中节点下" hide-footer>
            <b-form @submit="handleCopyFromSubscript" @reset="handleCopyFromSubscriptReset">
                <b-row class="my-1">
                    <b-col sm="3">
                        <label>节点前缀（选填）:</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-input id="serverName" type="text"
                                      v-model="imfOpcEocCopyFromSubscriptDto.nodeIdPrefix"></b-form-input>
                    </b-col>
                </b-row>
                <b-row align-h="end" style="margin-top: 30px">
                    <b-button type="submit" variant="primary">确定</b-button>
                    <b-button type="reset" variant="danger">取消</b-button>
                </b-row>
            </b-form>
        </b-modal>
        <sub-entity-list ref="eowEntityList" sub-entity="emOpcWatchEow"
                         parent-field="eowIdOrigin"></sub-entity-list>
        <sub-entity-list ref="eocaEntityList" sub-entity="emOpcComputedActionEoca"
                         parent-field="eocaIdEoc" size="xl"></sub-entity-list>
        <sub-entity-list ref="eoceEntityList" sub-entity="emOpcComputedEventEoce"
                         parent-field="eoceIdEoc"></sub-entity-list>
    </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-06-21 17:50:20

import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
import EmFilterTree from "@/components/em/EmFilterTree";
import EmFilter from "@/components/em/EmFilter";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import subEntityList from "@/components/em/EmModal/SubEntityList";
import emApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "emOpcComputedEocLevelTreeListView",
    mixins: [emLevelTreeListMixin, emCommonGotoMixin, emApiMixin, emTableCheckedMixin],
    components: {EmFilter, EmFilterTree, subEntityList},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            onReInit: false,
            onCopyFromSubscript: false,
            imfOpcEocCopyFromSubscriptDto: {
                nodeIdPrefix: "",
                parentEocId: 0
            }
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        reInit() {
            this.onReInit = true
            this.$_emApiMixin_post(this.$_emApiMixin_moduleBaseApi("emOpcComputedEoc") + "/emOpcUaResource/reInit", {})
                .then((res) => {
                    commonViewsUtil.showSuccess(this, "重新组态成功")
                    this.onReInit = false
                })
        },
        gotoEow(row) {
            this.$_emGotoMixin_gotoHolderList("emOpcWatchEow"
                , {eowIdOriginFilter: row.eocNodeId}
                , {eowIdOrigin: row.eocNodeId}, true, {})
        },
        gotoEoca(row) {
            this.$_emGotoMixin_gotoHolderList("emOpcComputedActionEoca"
                , {eocaIdEocFilter: row.id}
                , {eocaIdEoc: row.id}, true, {})
        },
        gotoEoce(row) {
            this.$_emGotoMixin_gotoHolderList("emOpcComputedEventEoce"
                , {eoceIdEocFilter: row.id}
                , {eoceIdEoc: row.id}, true, {})
        },
        popEow(row) {
            this.$refs.eowEntityList.showModal(row.eocNodeId)
        },
        popEoca(row) {
            this.$refs.eocaEntityList.showModal(row.id)
        },
        popEoce(row) {
            this.$refs.eoceEntityList.showModal(row.id)
        },
        handleCopyFromSubscript(event) {
            event.preventDefault()
            this.onCopyFromSubscript = true
            this.imfOpcEocCopyFromSubscriptDto.parentEocId = this.selectIds
            console.log(this.imfOpcEocCopyFromSubscriptDto)
            this.$_emApiMixin_post(this.$_emApiMixin_moduleBaseApi("emOpcComputedEoc") + "/emOpcComputedEoc/copyFromSubscript", this.imfOpcEocCopyFromSubscriptDto)
                .then(response => {
                    console.log(response)
                    let nodeNum = response.data.length
                    commonViewsUtil.showSuccess(this, `成功拷贝了【${nodeNum}】条计算属性`)
                    this.$refs.emListFilter.doQuery()
                }).finally(() => this.onCopyFromSubscript = false);
            this.$nextTick(() => {
                this.$bvModal.hide('modal-copy-from-subscript')
            })
        },
        handleCopyFromSubscriptReset() {
            this.$nextTick(() => {
                this.$bvModal.hide('modal-copy-from-subscript')
            })
        },
    }
}
</script>
